//TODO: compatible ie11
import 'babel-polyfill';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import App from './App';
import router from './router';

let locale = localStorage.getItem('brief') || navigator.language;

import ElementUI from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import ElementLocale from 'element-ui/lib/locale';

if(locale && locale.indexOf('zh') > -1) {
  locale = 'zh-CN';
  ElementLocale.use(zhLocale);
}else {
  ElementLocale.use(enLocale);
  locale = 'en-US';
}

import '@/common/css/index.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: locale,
  messages: {
    'zh-CN': require('./common/lang/zh-CN'),
    'en-US': require('./common/lang/en-US')
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js